<template>
  <b-dropdown
    class="select"
    boundary="window"
    ref="dropdown"
    :popper-opts="this.popperOptions"
    :class="{
      'select__invalid': state,
      'is-invalid': state,
      'select__wrapped-item': wrappedItem,
      'select--active': isDropdownOpen,
    }"
    :disabled="disabled"
    @hidden="$emit('hidden'); isDropdownOpen = false"
    @show="isDropdownOpen = true"
  >
    <template #button-content>
      <div class="select__dropdown-content-slot-wrapper">
        <slot
          class="select__dropdown-slot-content"
          name="content"
          v-bind="selectedOptionObject"
        >
          <div class="select__dropdown-content-wrapper">
            <span class="select__dropdown-content">
              {{ selectedOptionTextField }}
            </span>
          </div>
        </slot>
      </div>
    </template>
    <b-dropdown-item
      v-for="(item, index) in options"
      :key="index"
      @click="selectItem(item)"
    >
      <slot name="item" v-bind="item">
        <div> {{ item[textField] || item }} </div>
        <div
          v-for="(child, index) in item[itemsChildName]"
          class="select__child"
          :key="index"
        >
          {{ child[textField] || child }}
        </div>
      </slot>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import isObjectLike from 'lodash/isObjectLike';
import selectMixin from '@/components/mixins/selectMixin';
import popperOptsMixin from '@/services/popperOptsMixin';

export default {
  name: 'Select',
  mixins: [
    selectMixin,
    popperOptsMixin,
  ],
  props: {
    value: {
      type: [String, Boolean, Object, Number],
    },
    options: {
      type: Array,
      default: () => ([]),
    },
    itemsChildName: {
      type: String,
      default: 'children',
    },
    valueField: {
      type: String,
      default: 'value',
    },
    textField: {
      type: String,
      default: 'text',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    state: {
      type: Boolean,
      default: null,
    },
    skipInitializeValue: {
      type: Boolean,
      default: false,
    },
    wrappedItem: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selectedOptionObject: null,
    isDropdownOpen: false,
  }),
  beforeDestroy() {
    this.removeBlurEvent();
  },
  methods: {
    getDropdownButtonElement() {
      const refDropdown = this.$refs.dropdown;
      if (!refDropdown) return null;
      return refDropdown.$el.firstElementChild;
    },
    getValueObject(item) {
      return this.options
        .find((option) => {
          if (option[this.valueField] === undefined) {
            return this.comparePrimitiveValues(item, option);
          }
          const value = isObjectLike(item) ? item[this.valueField] : item;
          return option[this.valueField] === value;
        });
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"

.select
  position: relative !important
  width: 100%
  &__invalid ::v-deep
    .btn.dropdown-toggle
      border: 1px solid $color-danger !important
      border-radius: 3px
      &:focus
        border-color: $color-danger !important
        box-shadow: 0 0 0 0.2rem rgba(231, 15, 15, 0.25) !important
  &__dropdown-content-wrapper,
  &__dropdown-content-slot-wrapper
    display: block
    text-overflow: ellipsis
    overflow: hidden
    white-space: nowrap
    width: 95%
    text-align: left
  &__dropdown-content,
  &__dropdown-slot-content
    font-weight: normal
    text-transform: none
    color: var(--font-color-secondary)
  &__child
    font-size: .9rem
    color: var(--font-color-primary)
    font-weight: 300
    margin-left: 25px
    margin-top: 6px
  &--active
    ::v-deep
      button
        &:after
          transform: rotate(180deg)
  ::v-deep
    .dropdown-toggle
      width: inherit
    .dropdown-menu
      width: inherit
      min-width: max-content
      max-height: 180px
      padding: 2px 0
      overflow-y: auto
      overflow-x: visible
      border-radius: 0 0 5px 5px !important
      .dropdown-item
        min-height: 40px
        padding: 12px
        font-size: 16px
        line-height: 16px
        margin-bottom: 0
        cursor: default
      .dropdown-item:focus,
      .dropdown-item:hover
        background-color: $color-primary
        color: white
        .select__child
          color: white
    button
      cursor: default !important
      height: 34px !important
      min-height: 2.9rem !important
      padding: 0 10px !important
      border: 1px solid var(--color-border-dropdown)
      display: flex
      justify-content: space-between
      align-items: center
      background-color: var(--color-background-dark)
      &:after
        content: ""
        display: inline-block
        margin-left: 0.255em
        margin-bottom: 1px
        vertical-align: 0.255em
        border-top: 0.5em solid $color-gray-medium
        border-right: 0.4em solid transparent
        border-bottom: 0
        border-left: 0.4em solid transparent
        transition: .2s ease
      &.disabled
        background-color: $color-gray-select !important
        span
          color: $font-color-primary
.manage-fonts_18px
  .select ::v-deep button
    height: 42px !important
.manage-fonts_16px
  .select ::v-deep button
    height: 38px !important

.select__wrapped-item
  ::v-deep
    .dropdown-menu
      min-width: inherit

      .dropdown-item
        white-space: normal
</style>
